export const contactsData = {
  email: 'shubhamdubey.dubey4@gmail.com',
  phone: '+91-9839839111',
  linkedIn: 'https://www.linkedin.com/in/shubhamluke09',
  github: 'https://github.com/Luke0912',
  portfolio: 'https://dev-shubh.netlify.app/',
}